import dayjs from "dayjs";

export const SALES_PERIOD = {
	LastSevenDays: "7",
	LastThirtyDays: "30",
	LastNinetyDays: "90",
	ThisMonth: "month",
	CustomRange: "custom",
} as const;

export type SalesPeriod = (typeof SALES_PERIOD)[keyof typeof SALES_PERIOD];

export const SALES_PERIOD_OPTIONS: { value: SalesPeriod; label: string }[] = [
	{ value: SALES_PERIOD.LastSevenDays, label: "7 hari terakhir" },
	{ value: SALES_PERIOD.LastThirtyDays, label: "30 hari terakhir" },
	{ value: SALES_PERIOD.LastNinetyDays, label: "90 hari terakhir" },
	{ value: SALES_PERIOD.ThisMonth, label: "Bulan ini" },
	{ value: SALES_PERIOD.CustomRange, label: "Atur tanggal" },
];

export const DEFAULT_SALES_PERIOD = SALES_PERIOD.LastThirtyDays;
export const DEFAULT_CUSTOM_RANGE_START = "2026-09-07";
export const DEFAULT_CUSTOM_RANGE_END = "2026-10-07";
export const ALL_STORES_VALUE = "all";
export const ALL_STORES_LABEL = "Semua toko";

const FIXED_PERIOD_DAYS: Record<string, number> = {
	[SALES_PERIOD.LastSevenDays]: 7,
	[SALES_PERIOD.LastThirtyDays]: 30,
	[SALES_PERIOD.LastNinetyDays]: 90,
};
const INVALID_RANGE_DAYS = 30;

export type SalesPeriodFilter = {
	salesPeriod: SalesPeriod;
	customRangeStart: string;
	customRangeEnd: string;
};

export const DEFAULT_SALES_PERIOD_FILTER: SalesPeriodFilter = {
	salesPeriod: DEFAULT_SALES_PERIOD,
	customRangeStart: DEFAULT_CUSTOM_RANGE_START,
	customRangeEnd: DEFAULT_CUSTOM_RANGE_END,
};

// Invalid range counts as 30.
export const countCustomRangeDays = (rangeStart: string, rangeEnd: string) => {
	const startDate = dayjs(rangeStart);
	const endDate = dayjs(rangeEnd);
	if (!startDate.isValid() || !endDate.isValid() || endDate.isBefore(startDate))
		return INVALID_RANGE_DAYS;
	return endDate.diff(startDate, "day") + 1;
};

export const resolvePeriodDays = (periodFilter: SalesPeriodFilter) => {
	if (periodFilter.salesPeriod === SALES_PERIOD.CustomRange)
		return countCustomRangeDays(
			periodFilter.customRangeStart,
			periodFilter.customRangeEnd,
		);
	if (periodFilter.salesPeriod === SALES_PERIOD.ThisMonth)
		return dayjs().date();
	return FIXED_PERIOD_DAYS[periodFilter.salesPeriod] ?? INVALID_RANGE_DAYS;
};

export const resolvePeriodLabel = (periodFilter: SalesPeriodFilter) => {
	if (periodFilter.salesPeriod === SALES_PERIOD.CustomRange)
		return `${resolvePeriodDays(periodFilter)} hari`;
	const periodOption = SALES_PERIOD_OPTIONS.find(
		(option) => option.value === periodFilter.salesPeriod,
	);
	return (periodOption?.label ?? "").toLowerCase();
};

// Custom range uses end.
export const resolvePeriodEndDate = (periodFilter: SalesPeriodFilter) => {
	const customEnd = dayjs(periodFilter.customRangeEnd);
	return periodFilter.salesPeriod === SALES_PERIOD.CustomRange &&
		customEnd.isValid()
		? customEnd
		: dayjs();
};
